import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { UiPanelComponent } from '@template-ui/components';
import { UiButtonDirective } from '@template-ui/directives';
import type { WorkflowReadOnlyGraphSelection } from './workflow-read-only-graph.models';
import type { WorkflowRouteInspection } from './workflow-route-inspection';

/** Read-only path summary. The owner rechecks the exact selection before editor entry. */
@Component({
  selector: 'phms-workflow-route-inspection',
  imports: [UiPanelComponent, UiButtonDirective],
  templateUrl: './workflow-route-inspection.component.html',
  styleUrl: './workflow-route-inspection.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkflowRouteInspectionComponent {
  readonly route = input.required<WorkflowRouteInspection>();
  readonly blocked = input(false);
  readonly openEditor = output<WorkflowReadOnlyGraphSelection>();

  requestEditor(): void {
    if (!this.blocked() && this.route().canOpenEditor)
      this.openEditor.emit(this.route().selection);
  }
}
